<template>
    <div class="set_element_container">
        <button
            class="set_element_btn flip_toFront tooltipElement"
            @click="flipElement('to-front')"
        >
            <inline-svg
                :src="flip_to_front_icon"
                fill="#737373"
            />
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsPushToFront') }`" />
        </button>
        <button
            class="set_element_btn flip_toBack tooltipElement"
            @click="flipElement('to-back')"
        >
            <inline-svg
                :src="flip_to_back_icon"
                fill="#737373"
            />
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsPushToBack') }`" />
        </button>
    </div>
</template>

<script>
    import Tooltip from '@/components/Global/Tooltip.vue';
    import flip_to_back_icon from '@/assets/icons/layer_down.svg';
    import flip_to_front_icon from '@/assets/icons/layer_up.svg';

    export default {
        data() {
            return {
                flip_to_front_icon,
                flip_to_back_icon
            }
        },
        methods: {
            flipElement(direction) {
                this.$store.dispatch('FLIP_ELEMENT', direction);
            }
        },
        components: {
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .set_element_container {
        display: flex;
        background-color: unset;
        border: none;
        border-right: 1px solid #D4D4D4;
    }
    .set_element_btn {
        background-color: unset;
        border: unset;
        cursor: pointer;
        display: flex;
        align-content: center;
        justify-content: center;
    }
</style>